const card = "rounded-xl border bg-background border-border overflow-hidden mb-2 md:mb-2 shadow-lg md:shadow-lg";

const headerButton =
  "flex items-center gap-1.5 md:gap-1 w-full text-left px-2 py-1.5 md:px-3 md:py-2 border-b border-border hover:bg-accent transition-colors duration-100";

const expandIcon = "text-muted-foreground select-none text-[10px] md:text-xs w-3 shrink-0";

const addressName = "flex-1 font-mono font-bold text-[11px] md:text-[13px] text-foreground truncate";

const collapseIcon = "text-muted-foreground text-[10px] md:text-xs ml-0 md:ml-1";

const body = "px-1 py-1 md:px-2 md:py-1 border-l border-dashed border-border pl-2 md:pl-3";

export { card, headerButton, expandIcon, addressName, collapseIcon, body };
